module.exports = __webpack_public_path__ + "static/bbis-pipes-91acc93c0c4d455adcf27cee640d1b03.jpeg";